export default __webpack_public_path__ + "static/media/FHash2.935d7d73.mp3";